module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-ff1493.c174a02d.png";